
/*
* action types
*/

export const ESTATE_FETCH_ERROR = 'ESTATE_FETCH_ERROR';
export const ESTATE_FETCH_SUCCESS = 'ESTATE_FETCH_SUCCESS';
export const ESTATE_FILTER = 'ESTATE_FILTER';

/*
* other constants
*/

    // sellType: '',
    // bienType: 'vente',
    // reference: '',
    // city: '',
    // piecesMin: '',
    // surfaceMin: '',
    // prixMin: -1,
    // prixMax: -1,

const filterEstate = (estate, filters) => {

    if (filters.reference && estate.reference && estate.reference._cdata !== filters.reference) return false;
    if (estate.type_bien && !filters.bienType.map(a => a.checked ? a.text.toLowerCase() : undefined).includes(estate.type_bien._cdata.toLowerCase())) return false;
    if (estate.type_offre && !filters.sellType.map(a => a.checked ? a.label.toLowerCase() : undefined).includes(estate.type_offre._cdata.toLowerCase())) return false;
    if (estate.ville && filters.city.toLowerCase() && estate.ville._cdata.toLowerCase() !== filters.city.toLowerCase()) return false;

    if (estate.chambres && (parseInt(estate.chambres._text) < filters.chambresValues[0] || parseInt(estate.chambres._text) > filters.chambresValues[1])) return false;
    if (estate.surface_habitable && (parseInt(estate.surface_habitable._cdata) < filters.surfaceValues[0] || parseInt(estate.surface_habitable._cdata) > filters.surfaceValues[1])) return false;
    if (estate.prix && (parseInt(estate.prix._text) < filters.prixValues[0] || parseInt(estate.prix._text) > filters.prixValues[1])) return false;

    return true;
}

/*
* action creators
*/

export function setEstateError() {
    return { type: ESTATE_FETCH_ERROR };
}

export function setEstateData(data) {
    return { type: ESTATE_FETCH_SUCCESS, payload: data };
}

export function setFilteredEstate(data) {
    return { type: ESTATE_FILTER, payload: data.estates.filter(estate => filterEstate(estate, data.filters)) };
}
